module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_2_2-7efd49434214612edbf3ff619e7607d0.png";